import { Revalidator, RevalidatorOptions, SWRConfiguration } from 'swr';

import { ApiError } from './models';

export const APP_NAME = 'ori-security-identity-ui';
export const PACKAGE_NAME = '@ori/login-page';

export const EMOTION_CACHE_KEY = `${APP_NAME}-emotion-cache-key`;

export const APP_ROOT_ELEMENT_ID = `${APP_NAME}-root`;

export const NOT_LOGGED_IN_USER_ID = -1;

/**
 * SWR config
 */
export const swrConfig: SWRConfiguration = {
  errorRetryCount: 3,
  errorRetryInterval: 10000,
  focusThrottleInterval: 300000,
  shouldRetryOnError: true,
  suspense: false,
  /* eslint-disable max-params -- library requires too many parameters */
  onErrorRetry: (
    error: ApiError,
    key: string,
    config: SWRConfiguration,
    revalidate: Revalidator,
    { retryCount }: RevalidatorOptions,
  ) => {
    const statusCode = Number(error?.data?.status ?? 200);

    if (statusCode >= 400 && statusCode < 500) {
      return;
    }

    const rCount = retryCount ?? 1;

    if (rCount >= (config.errorRetryCount ?? 0)) {
      return;
    }

    setTimeout(() => void revalidate({ retryCount: rCount }), config.errorRetryInterval);
  },
  /* eslint-enable max-params */
};

export { default as axiosClient } from 'axios';
